(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["suminagashi-single-line-title"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sumi-fit-title')) {
    customElements.define('sumi-fit-title', class extends HTMLElement {
      connectedCallback() {
        this.titleText = this.querySelector('.sm-product-title-lines');
        this.observedWidth = null;
        this.observer = new ResizeObserver((entries) => {
          const width = entries[0].contentRect.width;
          if (width !== this.observedWidth) {
            this.observedWidth = width;
            this.scheduleFit();
          }
        });
        this.observer.observe(this);
        this.scheduleFit();
        if (document.fonts) {
          document.fonts.ready.then(() => {
            if (this.isConnected) this.scheduleFit();
          });
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.fitFrame);
      }

      scheduleFit() {
        cancelAnimationFrame(this.fitFrame);
        this.fitFrame = requestAnimationFrame(() => this.fitTitle());
      }

      fitTitle() {
        if (!this.titleText || !this.isConnected) return;
        const availableWidth = this.clientWidth;
        if (availableWidth <= 0) return;
        this.style.removeProperty('font-size');
        const naturalSize = parseFloat(getComputedStyle(this).fontSize);
        const naturalWidth = this.titleText.scrollWidth;
        if (naturalWidth > availableWidth) {
          const fittedSize = Math.floor(naturalSize * (availableWidth - 1) / naturalWidth * 100) / 100;
          this.style.fontSize = `${fittedSize}px`;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
